import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  exposure_value: {
    name: 'Net credit exposure',
    isStatic: false
  },
  bic: {
    name: "CCP's BIC",
    isStatic: false
  },
  lei: {
    isStatic: false,
    name: "CCP's LEI"
  },
  name: {
    name: "CCP's name",
    isStatic: false
  },
  clear_transactions_through_ccp_flag: {
    name: 'Direct clearing flag',
    isStatic: false,
    withoutLetter: true
  }
};

export function ExposuresCPP({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.CCP_EXPOSURE,
    onChangeFund,
    schema: schema.CCP_EXPOSURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.CCP_EXPOSURE?.field_names || [],
    tableName: 'CCP_EXPOSURE',
    order: 203,
    isMultiFunds,
    funds,
    columnLables
  });

  return (
    <StyledTables id="fca-reporttables-exposures-cpp-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-exposures-cpp-table-${index + 1}`}
          key={index + 'CCP_EXPOSURE'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
